import Link from "next/link";
import { IoIosHome } from "react-icons/io";
import { MdKeyboardArrowRight } from "react-icons/md";
import styled from "styled-components";
import { useRouter } from "./useRouter";

const Crum = styled.div`
  svg {
    position: absolute;
    top: 0;
    right: 0;
    margin: auto;
    bottom: 0;
  }
  li:last-child {
    svg {
      display: none;
    }
  }
  li:first-child {
    padding-left: 0;
  }
`;
const Breadcrum = ({ className = "" }) => {
  let router = useRouter();
  return (
    <Crum
      className={`text-[16px] lg:text-[22px] lg:pb-[20px] flex ${className}`}
    >
      <nav className="main-wrapper" aria-label="breadcrumb">
        <ol className="flex flex-wrap">
          <li className="breadcrumb-item breadcrum-list relative p-[0_16px] md:p-[2px_26px_2px_16px]">
            <Link tabIndex="0" href="/">
              <IoIosHome />
            </Link>
          </li>
          {router.pathSegments.length > 0 && (
            <li className="w-[16px] relative lg:ml-[12px]">
              <MdKeyboardArrowRight />
            </li>
          )}
          {router.pathSegments.map((segment, index) => (
            <li
              key={index}
              className="breadcrumb-item breadcrum-list relative p-[2px_16px_2px_4px] md:p-[2px_26px_2px_16px]"
            >
              <MdKeyboardArrowRight />
              <Link
                className="no-wrap"
                href={`/${router.pathSegments.slice(0, index + 1).join("/")}`}
              >
                {segment}
              </Link>
              <MdKeyboardArrowRight />
            </li>
          ))}
        </ol>
      </nav>
    </Crum>
  );
};

export default Breadcrum;
